module.exports = __webpack_public_path__ + "epdf-app/dashboard/message/message-3Q7uzjlh.html";